export default {
  modelName: 'ExerciseEntry',
  attributes: {
    birlExerciseId: {
      name: 'birlExerciseId',
      apiName: 'birlExerciseId',
      camelName: 'birlExerciseId',
      underscoreName: 'birl_exercise_id',
      type: 'integer',
      writeable: true,
      default: null,
      humanName: 'Birl Exercise'
    },
    comment: {
      name: 'comment',
      apiName: 'comment',
      camelName: 'comment',
      underscoreName: 'comment',
      type: 'string',
      writeable: true,
      default: null,
      humanName: 'Comment'
    },
    createdAt: {
      name: 'createdAt',
      apiName: 'createdAt',
      camelName: 'createdAt',
      underscoreName: 'created_at',
      type: 'datetime',
      writeable: true,
      default: null,
      humanName: 'Created At'
    },
    dodoneId: {
      name: 'dodoneId',
      apiName: 'dodoneId',
      camelName: 'dodoneId',
      underscoreName: 'dodone_id',
      type: 'integer',
      writeable: true,
      default: null,
      humanName: 'Dodone'
    },
    executedAt: {
      name: 'executedAt',
      apiName: 'executedAt',
      camelName: 'executedAt',
      underscoreName: 'executed_at',
      type: 'datetime',
      writeable: true,
      default: null,
      humanName: 'Executed At'
    },
    full: {
      name: 'full',
      apiName: 'full',
      camelName: 'full',
      underscoreName: 'full',
      type: 'string',
      writeable: true,
      default: null,
      humanName: 'Full'
    },
    id: {
      name: 'id',
      apiName: 'id',
      camelName: 'id',
      underscoreName: 'id',
      type: 'integer',
      writeable: false,
      default: null,
      humanName: 'Id'
    },
    reps: {
      name: 'reps',
      apiName: 'reps',
      camelName: 'reps',
      underscoreName: 'reps',
      type: 'string',
      writeable: true,
      default: null,
      humanName: 'Reps'
    },
    series: {
      name: 'series',
      apiName: 'series',
      camelName: 'series',
      underscoreName: 'series',
      type: 'jsonb',
      writeable: true,
      default: '[]',
      humanName: 'Series'
    },
    updatedAt: {
      name: 'updatedAt',
      apiName: 'updatedAt',
      camelName: 'updatedAt',
      underscoreName: 'updated_at',
      type: 'datetime',
      writeable: true,
      default: null,
      humanName: 'Updated At'
    },
    userId: {
      name: 'userId',
      apiName: 'userId',
      camelName: 'userId',
      underscoreName: 'user_id',
      type: 'integer',
      writeable: true,
      default: null,
      humanName: 'User'
    },
    weightSignature: {
      name: 'weightSignature',
      apiName: 'weightSignature',
      camelName: 'weightSignature',
      underscoreName: 'weight_signature',
      type: 'string',
      writeable: true,
      default: null,
      humanName: 'Weight Signature'
    }
  },
  names: {
    model: 'Birl::ExerciseEntry',
    base: 'exercise_entry',
    baseSingularClass: 'ExerciseEntry',
    human: 'Exercise Entry',
    singularCamelFull: 'birlExerciseEntry',
    singularCamel: 'exerciseEntry',
    singularClassFull: 'BirlExerciseEntry',
    singularClass: 'ExerciseEntry',
    singularDash: 'exercise-entry',
    singularUnderscoreFull: 'birl_exercise_entry',
    singularUnderscore: 'exercise_entry',
    singularUnderscorePath: 'birl/exercise_entry',
    pluralModel: 'Birl::ExerciseEntries',
    pluralCamelFull: 'birlExerciseEntries',
    pluralCamel: 'exerciseEntries',
    pluralClass: 'ExerciseEntries',
    pluralDash: 'exercise-entries',
    pluralUnderscoreFull: 'birl_exercise_entries',
    pluralUnderscore: 'exercise_entries',
    pluralUnderscorePath: 'birl/exercise_entries'
  },
  validators: [
    {
      className: 'ActiveRecord::Validations::PresenceValidator',
      options: {
        message: 'required',
        if: null
      },
      attributes: ['user']
    },
    {
      className: 'ActiveRecord::Validations::PresenceValidator',
      options: {
        message: 'required',
        if: null
      },
      attributes: ['birl_exercise']
    },
    {
      className: 'ActiveRecord::Validations::PresenceValidator',
      options: {
        message: 'required',
        if: null
      },
      attributes: ['dodone']
    }
  ],
  enums: {}
}
